import React, { Children } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { text } from '../Theme/palette'
import typography, { fontWeight } from '../Theme/typography'

export const cssFuncs = {
  variant: (variant, theme) => `
    font-size: ${theme?.typography?.[variant]?.fontSize}px;
    line-height: ${theme?.typography?.[variant]?.lineHeight};
    font-weight: ${theme?.typography?.[variant]?.fontWeight};
    ${
      theme?.typography?.[variant]?.letterSpacing
        ? `letter-spacing: ${theme?.typography?.[variant]?.letterSpacing}px;`
        : ''
    }
    ${
      theme?.typography?.[variant]?.textTransform
        ? `text-transform: ${theme?.typography?.[variant]?.textTransform};`
        : ''
    }
    ${
      theme?.typography?.[variant]?.textDecoration
        ? `text-decoration: ${theme?.typography?.[variant]?.textDecoration};`
        : ''
    }
    ${theme?.typography?.[variant]?.fontFamily ? `font-family: ${theme?.typography?.[variant]?.fontFamily};` : ''}
    ${theme?.typography?.[variant]?.cursor ? `cursor: ${theme?.typography?.[variant]?.cursor};` : ''}
    ${
      theme?.typography?.[variant]?.hasOwnProperty('sm')
        ? theme.mixins.mq(
            `
      font-size: ${theme?.typography?.[variant]?.sm.fontSize}px;
      line-height: ${theme?.typography?.[variant]?.sm.lineHeight};
      ${
        theme?.typography?.[variant]?.letterSpacing
          ? `letter-spacing: ${theme?.typography?.[variant]?.letterSpacing}px;`
          : ''
      }
    `,
            'sm',
          )
        : ''
    }
    ${
      theme?.typography?.[variant]?.hasOwnProperty('md')
        ? theme.mixins.mq(
            `
      font-size: ${theme?.typography?.[variant]?.md.fontSize}px;
      line-height: ${theme?.typography?.[variant]?.md.lineHeight};
      ${
        theme?.typography?.[variant]?.letterSpacing
          ? `letter-spacing: ${theme?.typography?.[variant]?.letterSpacing}px;`
          : ''
      }
    `,
            'md',
          )
        : ''
    }
    ${
      theme?.typography?.[variant]?.hasOwnProperty('lg')
        ? theme.mixins.mq(
            `
      font-size: ${theme?.typography?.[variant]?.lg.fontSize}px;
      line-height: ${theme?.typography?.[variant]?.lg.lineHeight};
      ${
        theme?.typography?.[variant]?.letterSpacing
          ? `letter-spacing: ${theme?.typography?.[variant]?.letterSpacing}px;`
          : ''
      }
    `,
            'lg',
          )
        : ''
    }
  `,
  weight: (weight, theme) => `font-weight: ${theme.globals.fontWeight[weight]};`,
  textAlign: textAlign => `text-align: ${textAlign};`,
  upper: () => `text-transform: uppercase;`,
  color: (color, theme) => `color: ${theme.palette.text[color]};`,
  blend: blend => `opacity: ${blend === 'main' ? '.6' : blend === 'dark' ? '.8' : '.6'};`,
  maxX: width => `max-width: ${width};`,
  minX: width => `min-width: ${width};`,
  mB: (margin, theme) => `margin-bottom: ${theme.spacing(margin)}px;`,
  wrap: wrap => `white-space: ${wrap};`,
  strike: () => `text-decoration: line-through;`,
  decoration: decoration => `text-decoration: ${decoration};`,
  inline: () => `display: inline;`,
  selectable: () =>
    `user-select: none; cursor: pointer; -webkit-tap-highlight-color: rgba(0,0,0,0); -webkit-tap-highlight-color: transparent;`,
}

const T = styled.div`
  ${props => props.theme.mixins.runCSSFuncs(props, cssFuncs)}
`

const Type = props => {
  const { variant, messages, children, values } = props
  return (
    <T as={typography?.[variant]?.el || 'div'} {...props}>
      {messages ? <FormattedMessage {...messages} values={values} /> : Children.toArray(children)}
    </T>
  )
}

Type.propTypes = {
  variant: PropTypes.oneOf(Object.keys(typography)),
  weight: PropTypes.oneOf(Object.keys(fontWeight)),
  upper: PropTypes.bool,
  color: PropTypes.oneOf(Object.keys(text)),
  maxX: PropTypes.any,
  messages: PropTypes.object,
  blend: PropTypes.oneOf([true, false, 'main', 'dark']),
  values: PropTypes.object,
}

Type.defaultProps = {
  variant: 'p',
}

export default Type
